/**
 * Canonical UI-locale keys, shared between backend (validation of the stored
 * `user.ui_locale`) and frontend (the picker / Lingui activation).
 *
 * One DB column (`user.ui_locale`) stores the user's personal interface
 * language. `null` / unknown values fall through to localStorage, then the
 * browser, then English.
 */

export const UI_LOCALES = ["en", "nl"] as const;

export type TUiLocale = (typeof UI_LOCALES)[number];

export function isUiLocale(value: unknown): value is TUiLocale {
	return typeof value === "string" && (UI_LOCALES as readonly string[]).includes(value);
}
